<template>
  <v-card>
    <v-card-title>{{ $t('application.events') }}</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="this.data.events"
        hide-default-headers
        hide-default-footer
        disable-pagination
        disable-sort
      >
        <template v-slot:item.timestamp="{item}">
          {{ item.timestamp | datetime }}
        </template>
        <template v-slot:item.eventType="{item}">
          {{ $t('events.'+item.eventType) }}
        </template>
        <template v-slot:item.userId="{item}">
          {{ item.user ? item.user.firstName+" "+item.user.lastName : item.userId }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
  } from 'vuetify/lib'

  export default {
    name: 'FCCApplicationEvents',
    filters: {
      ms: function(value) {
        return Math.floor(parseFloat(value))+" ms";
      },
      timestamp: function(value) {
        var re = new RegExp(/(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)/);
        var r = value.match(re);
        return parseInt(r[4])+":"+parseInt(r[5]);
      }
    },
    props: {
      data: Object
    },
    computed: {
      headers: function(){
        return [
          { text: this.$t('ctrl.timestamp'), value: 'timestamp', align: 'left' },
          { text: this.$t('ctrl.name'), value: 'eventType', align: 'left' },
          { text: this.$t('ctrl.user'), value: 'userId', align: 'left' },
        ];
      }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable
    }
  }
</script>